import React from 'react';
import { motion } from 'framer-motion';
import emailjs from 'emailjs-com';

function Social({ href, icon, name }) {
  return (
    <div className="flex justify-center items-center flex-col gap-2">
      <a href={href} target="_blank" rel="noopener noreferrer">
        <img src={icon} alt={name} />
      </a>
      <p className="text-[1.5rem] text-[#7950F2] font-bold">{name}</p>
    </div>
  );
}

function Card({ name, src, Email, Github, Linkdin, Tel }) {
  return (
    <motion.div
      className="
        w-full max-w-[620px] min-[900px]:w-[60%]
        h-auto min-[900px]:h-[30%]
        flex justify-center items-stretch
        px-4 sm:px-6 md:px-8 py-2
      "
      initial={{ x: '-100%' }}
      whileInView={{ x: '0%' }}
      transition={{ duration: 0.8 }}
    >
      <div
        className="
          shadow-lg shadow-[#222] rounded-[2rem] bg-[rgba(59,59,59,0.6)]
          flex items-center justify-center gap-6 sm:gap-8 p-6 sm:p-8
          flex-wrap min-[900px]:flex-nowrap
        "
      >
        <Social name="Email" href={Email} icon="/assets/Icons/email.svg" />
        <Social name="Github" href={Github} icon="/assets/Icons/github.svg" />
        <Social name="Linkedin" href={Linkdin} icon="/assets/Icons/linkedin.svg" />
        <Social name="Telephone" href={Tel} icon="/assets/Icons/whatsapp.svg" />
      </div>
    </motion.div>
  );
}

function Contact() {
  const handleSubmit = (event) => {
    event.preventDefault();
    emailjs
      .sendForm('service_pdtlwjn', 'template_z38yerl', event.target, 'sDG9TvTkVDDNqTXNm')
      .then(
        () => alert('Message sent successfully'),
        () => alert('Failed to send message')
      );
  };

  return (
    <div
      id="contact"
      className="
        bg-cover bg-center w-full overflow-hidden
        min-[900px]:h-[100vh] min-h-[70rem]
        px-4 sm:px-6 md:px-8
        py-10 min-[900px]:py-0
        grid grid-cols-1 min-[900px]:grid-cols-2
        gap-10 min-[900px]:gap-10
        justify-items-center items-center
      "
    >
      <div className="icon-links">
        <Card
          name="Salma Inane"
          src="/assets/Static/IMG/Weare/MBQ.jpg"
          Email="mailto:inanesalma4@gmail.com"
          Github="https://github.com/Sal-Inn"
          Linkdin="https://www.linkedin.com/in/salma-inane-883574232/"
          Tel="tel:+212624638928"
        />
      </div>

      <div className="contact-form">
        <form
          onSubmit={handleSubmit}
          className="
            w-full max-w-[600px]
            flex flex-col gap-3
            p-4 rounded-lg
            "
          style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}
        >
          <p style={{ color: 'white', fontSize: '30px', fontWeight: 'bold' }}>
            Send your email message here
          </p>

          <input
            type="text"
            name="name"
            placeholder="First Name"
            required
            className="input-field form-input px-4 py-2 border border-gray-600 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-20"
          />
          <input
            type="text"
            name="surname"
            placeholder="Last Name"
            required
            className="input-field form-input px-4 py-2 border border-gray-600 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-20"
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            required
            className="input-field form-input px-4 py-2 border border-gray-600 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
          />
          <textarea
            name="message"
            placeholder="Your message here..."
            required
            className="textarea-field form-textarea px-4 py-2 border border-gray-600 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
          />
          <button
            type="submit"
            className="submit-button bg-[#7950F2] text-white px-4 py-2 rounded-md hover:bg-blue-600"
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
}

export default Contact;
